import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Grid,
  Typography,
  withStyles,
} from '@material-ui/core'
import startCase from 'lodash/startCase'

import HotelCard from '../components/itinerary/hotel/HotelCard'
import TripHeader from '../components/trip/TripHeader'
import AppTopBar from '../components/AppTopBar'
import Helmet from 'react-helmet'

import './App.css'
import { config } from '../config.js'

const API = config.api.TRAVEL_URL + '/hotels'

class Hotels extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hotels: [],
      isLoading: false,
      error: false,
      hotel: null,
      trip: null,
      address: props.address || props.locationTo,
    }
  }

  componentDidMount() {
    if (!this.state.isLoading) {
      this.fetchHotels(this.props);
    }
  }

  fetchHotels(props) {
    this.setState({ isLoading: true })

    window.gtag('event', 'search', {group: 'Hotel'});

    fetch(API, {
      headers: {
        'X-USER': props.user_id,
        'X-TRIP': props.trip_id
      }
    })
      .then(response => response.json())
      .then(response => {
        this.setState(previousState => ({
          hotels: (response.entries || []),
          destination: response.destination,
          trip: response.trip,
          isLoading: false
        }));
      })
      .catch((err) => this.setState({ isLoading: false, error: true }))
  }

  handleClickBack = () => {
    this.props.history.push(`/trips/${this.props.trip_id}`)
  }

  render() {
    const { classes } = this.props;
    const firstPrice = this.state.hotels[0] ? this.state.hotels[0].priceQuote.amount : null

    return (
      <Fragment>
        <Helmet>
          <title>{`Find Cheap Vacation Rentals near ${startCase(this.props.destination ? this.props.destination.to : this.state.address)} ${firstPrice ? 'for $' + firstPrice : ''}`}</title>
        </Helmet>
        <AppTopBar
           onLocationChanged={this.props.onLocationChanged}
           onLocationCleared={this.props.onLocationCleared}
           onChange={this.props.onFilterChange}
           address={this.props.address}
           hideSearchBar={true}
        />
        <div className="layout">
          <div className="search-container">
            <TripHeader
              to={this.props.destination ? this.props.destination.to : this.state.address}
              startDate={this.state.trip ? this.state.trip.start_date : this.props.search_params.start_date}
              endDate={this.state.trip ? this.state.trip.end_date : this.props.search_params.end_date}
              nights={this.props.search_params && this.props.search_params.nights}
              adults={this.props.search_params && this.props.search_params.adults}
              children={this.props.search_params && this.props.search_params.children}
              infants={this.props.search_params && this.props.search_params.infants}
              flightPrice={this.state.flight && this.state.flight.price}
              hotelPrice={this.state.hotel && this.state.hotel.priceQuote.amount}
              searchParams={this.props.search_params}
              address={this.state.address}
              isLoading={this.state.isLoading}
              destination={this.props.destination}
              showStepper={true}
              activeStep={2}
            />
          </div>
        </div>
        <div className="trip-container">
          <Grid item xs={12} className={classes.gridFilters}>
            <div className="hotels-container">
              <Grid
                container
                alignItems={'center'}
                justify={'center'}>
                  <Grid item xs={12} className={classes.header}>
                    {/* <div className={classes.actions}>
                      <Button size="medium" variant="outlined" className={classes.buttonSort}>
                        <Icon className={classes.iconSort}>sort</Icon>
                        Recommended
                      </Button>
                    </div> */}

                    <Typography className={classes.section}>
                      {/* <Icon className={classes.icon}>hotel</Icon> */}
                      <Fragment>
                        Choose accommodation<br/>
                        <small>Additional taxes and fees may apply.</small>
                      </Fragment>
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                  {this.state.hotels &&
                    this.state.hotels
                              .sort((a, b) => a.priceQuote.amount - b.priceQuote.amount)
                              .map((hotel, index) => {
                    return (hotel &&
                            <HotelCard key={hotel.listingId}
                                      hotel={hotel}
                                      onSelected={this.props.onSelected.bind(this, hotel, this.props.trip_id, this.props.locationFrom, this.props.locationTo)}
                                      selected_hotel_id={this.props.hotel_id}
                                      search_params={this.props.search_params}
                                      destination={this.state.destination}
                                      user_id={this.props.user_id}
                                      trip_id={this.props.trip_id}
                                      classes={{root: classes.root}} />)
                  })}
                  </Grid>
                  {this.state.isLoading === false && this.state.hotels.length < 1 && <Grid container className={classes.notFound}>
                    <Typography>We couldn't find any available room near your destination</Typography>
                  </Grid>}
              </Grid>
            </div>
          </Grid>
        </div>
      </Fragment>
    );
  }
}

const styles = theme => ({
  section: {
    fontSize: 19,
    fontWeight: 600,
    padding: '25px 15px 15px 0px',
    lineHeight: '1.3',

    '& small': {
      color: '#999',
      fontSize: '70%',
      fontWeight: 400,
    }
  },
  header: {
    padding: '0px !important',
  },
  actions: {
    float: 'right',
  },
  buttonSort: {
    color: '#444',
    textTransform: 'capitalize',
    border: '1px solid #eee',
    fontWeight: 500,
    fontSize: 12,
    height: 40,
    marginTop: 10,
    // backgroundColor: '#eee',
  },
  iconSort: {
    padding: '0 !important',
    fontSize: 18,
    marginTop: -3,
    marginRight: 5,
  },
  gridFilters: {
    textAlign: 'left',
    maxWidth: 1130,
    margin: '0px auto',
  },
  root: {
    width: '100%',
    boxShadow: 'none',
    border: '1px solid #ddd',
    margin: '10px 0px',
    borderRadius: 4,

    '&::before': {
      backgroundColor: 'transparent',
    },
    '&:hover': {
      border: ' 1px solid #eee',
      boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    },
  },
  buttonBack: {
    float: 'left',
    marginRight: 10,
    color: '#777',

    '& .material-icons': {
      padding: 0,
    },
  },
  icon: {
    verticalAlign: 'middle !important',
    display: 'block',
    float: 'left',
    padding: '4px 11px 5px 5px !important',
  },
  notFound: {
    textAlign: 'center',
    padding: 50,
    borderRadius: 3,
    display: 'block',
    backgroundColor: '#fff',
    border: '1px solid #eee',
  },
})

export default withStyles(styles)(withRouter(Hotels));
